import React, { useCallback } from "react";
import Text from "../Text";
import { CommonPropertyProps } from "schemas/elements";
import { toNumber } from "lodash";

type Props = Omit<CommonPropertyProps, "value"> & {
	value: { [k: string]: string | number } | string | number;
	nextProp?: string;
};

export default ({
	updateStore,
	field,
	required,
	value,
	desc,
	validation,
	elementIndex,
	nextProp,
	id,
	nestedField,
}: Props) => {
	const props = {
		updateStore,
		field,
		required,
		value,
		desc,
		validation,
		elementIndex,
		type: "number",
		nextProp,
		id,
		nestedField,
	};

	const formatNumber = useCallback((input: string) => {
		if (input === "") {
			return undefined;
		} else {
			try {
				const asNumber = toNumber(input);
				if (isNaN(asNumber)) {
					return undefined;
				} else {
					return asNumber;
				}
			} catch {
				return undefined;
			}
		}
	}, []);

	return <Text {...props} format={formatNumber} />;
};
